import { render, staticRenderFns } from "./ExternalPostTagTable.vue?vue&type=template&id=154db9a4&scoped=true"
import script from "./ExternalPostTagTable.vue?vue&type=script&lang=js"
export * from "./ExternalPostTagTable.vue?vue&type=script&lang=js"
import style0 from "./ExternalPostTagTable.vue?vue&type=style&index=0&id=154db9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154db9a4",
  null
  
)

export default component.exports